import React, { useState } from "react";
import PaymentView from "components/payment";
import { useTranslation } from "i18n";

const Payment = ({
  id,
  handleOnSuccessPaymentRequest,
  tikkieUrl,
  onNewApplication,
}) => {
  const { t } = useTranslation();
  const [paymentType, setPaymentType] = useState();
  const choseTikkie = paymentType === 4;

  return (
    <section className="entry-fee-panel entry-fee-pay">
      <header className="entry-fee-panel__head">
        <p className="entry-fee-kicker">{t("entryFee.steps.payment")}</p>
        <h2>{t("entryFee.payment.title")}</h2>
        <p>{t("entryFee.payment.lead")}</p>
      </header>
      <PaymentView
        tikkieUrl={tikkieUrl}
        handleOnSuccessPaymentRequest={handleOnSuccessPaymentRequest}
        setPaymentType={setPaymentType}
        paymentType={paymentType}
        totalPrice={233}
        totalAmount={22}
        currency={{ currency: "EUR", sign: " € " }}
        id={id}
        onlyTikkiePayment
      />
      {choseTikkie && (
        <div className="entry-fee-actions">
          <button
            type="button"
            className="entry-fee-new"
            onClick={onNewApplication}
          >
            {t("entryFee.payment.newApplication")}
          </button>
        </div>
      )}
    </section>
  );
};

export default Payment;
